import ZImage from "./ZImage";

export default ZImage;
